import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import axios from 'axios'
import { API_URL } from '../../../constants'
import { ApiResponse } from '../api/response.types'
import { ISelectOptionWith } from '../types/select'
import { SelectStyles } from '../../../components/Select'
import { useThemeMode } from '../../../_metronic/partials'

// value = name (идентификатор опции), label = "name — id", id — по нему фильтрует ClientsSearch.
type RequisiteOption = ISelectOptionWith<string, { id: number }>

const RequisiteMultipleFilter = ({ changeSelect }: { changeSelect: any }) => {
  const { mode: theme } = useThemeMode()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [requisites, setRequisites] = useState<RequisiteOption[]>([])

  useEffect(() => {
    axios
      .get<ApiResponse<RequisiteOption[]>>(`${API_URL}/api/internal/requisite/lookup`)
      .then((res) => {
        if (res.data.success) {
          setRequisites(res.data.data ?? [])
        }
        setIsLoading(false)
      })
  }, [])

  return isLoading ? (
    <>Загрузка реквизитов...</>
  ) : (
    <Select
      onChange={(data) => {
        changeSelect({ type: 'requisites', value: data })
      }}
      isMulti={true}
      options={requisites}
      placeholder={'Реквизит'}
      styles={SelectStyles(theme)}
    />
  )
}

export default RequisiteMultipleFilter
